import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  DEFAULT_SECTION = "urgentSection"
  DEFAULT_SECTION_TAB = "urgentSectionTab"

  static targets = [
    "tab",
    "navbar",
    "section",
    "urgentSection",
    "techAlertSection",
    "attentionSection",
    "analysisSection",
  ]
  static classes = ["hidden"]
  static values = { mobileDevice: Boolean }

  connect() {
    this.initNavbar()
  }

  initNavbar() {
    if (this.mobileDeviceValue || this.navbarTarget.checkVisibility()) {
      this.#change_displayed_section(this.DEFAULT_SECTION, this.DEFAULT_SECTION_TAB)
    }
  }

  selectSection({ params: { selectedSection, selectedSectionTab }}) {
    this.#change_displayed_section(selectedSection, selectedSectionTab)
  }

  #change_displayed_section(selectedSection, selectedSectionTab) {
    this.#reset()
    this.#display_selected_section(selectedSection, selectedSectionTab)
  }

  #reset() {
    this.tabTargets.forEach(tab => delete tab.dataset.active)
    this.sectionTargets.forEach(section => section.classList.add(this.hiddenClass))
  }

  #display_selected_section(selectedSection, selectedSectionTab) {
    this.targets.find(selectedSection).classList.remove(this.hiddenClass)
    this.tabTargets.find(tab => tab.id === selectedSectionTab).dataset.active = true
  }
}
